/**
 * MFP First-Order Free Gift — mfp-first-order-gift.js
 * 
 * Auto-adds Bacteriostatic Water (10ml) to the cart for first-time customers
 * and applies the WELCOMEGIFT discount code.
 * 
 * Customer detection:
 *   - Logged-in: checks orders_count == 0 via Liquid (server-side)
 *   - Guest: treated as potentially first-time (once_per_customer on discount
 *     prevents double-use for logged-in; guests get a polite attempt)
 * 
 * Price rule ID: 1754101842166 | Discount code: WELCOMEGIFT
 * BAC Water Product ID: 9358534705398
 * BAC Water Variant ID (10ml): 51583208849654
 */
(function () {
  'use strict';

  var CFG = window.MFP_GIFT_DATA;
  if (!CFG) return; // Snippet not included or data missing

  // Only run for first-time customers
  if (!CFG.isFirstTime) return;

  var BAC_VARIANT_ID = CFG.bacVariantId;
  var DISCOUNT_CODE  = CFG.discountCode;
  var STORAGE_KEY    = 'mfp_bac_gift_v1';

  // Don't re-add in same session if already handled
  try {
    if (localStorage.getItem(STORAGE_KEY) === 'done') return;
  } catch (e) {}

  /* ── Helpers ── */
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function addBacToCart() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: BAC_VARIANT_ID, quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function applyDiscountCode(code) {
    // Apply discount via redirect — Shopify sets it as a cookie/session
    // Works for both guest and logged-in customers
    var img = new Image();
    img.src = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
  }

  function showGiftToast(message) {
    var toast = document.createElement('div');
    toast.id = 'mfp-gift-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'right:24px',
      'background:#0f2044',
      'color:#c9a84c',
      'padding:16px 22px',
      'border-radius:12px',
      'z-index:100000',
      'font-family:"Roboto Condensed",sans-serif',
      'font-weight:700',
      'font-size:15px',
      'max-width:340px',
      'box-shadow:0 6px 24px rgba(0,0,0,0.35)',
      'line-height:1.5',
      'transition:opacity 0.4s ease'
    ].join(';');
    toast.innerHTML = message;
    document.body.appendChild(toast);
    // Auto-dismiss after 7s
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }, 7000);
  }

  function markDone() {
    try { localStorage.setItem(STORAGE_KEY, 'done'); } catch (e) {}
  }

  /* ── Main flow ── */
  function run() {
    getCart()
      .then(function (cart) {
        // Check if BAC water already in cart
        var items = cart.items || [];
        var alreadyIn = items.some(function (item) {
          return String(item.variant_id) === String(BAC_VARIANT_ID);
        });

        if (alreadyIn) {
          markDone();
          return;
        }

        // Add BAC water to cart
        return addBacToCart();
      })
      .then(function (result) {
        if (!result) return; // already in cart path
        if (result.status === 422 || result.description) {
          // Out of stock or error — log quietly
          console.log('[MFP Gift] Could not add BAC water:', result.description || result.status);
          return;
        }
        markDone();
        // Apply the discount code
        applyDiscountCode(DISCOUNT_CODE);
        // Notify cart drawer/cart icon to refresh
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // Show toast
        showGiftToast(
          '\uD83C\uDF81 <strong>New Customer Bonus!</strong><br>' +
          '<span style="color:#fff;font-weight:400;font-size:13px">' +
          'Free Bacteriostatic Water (10ml) added to your cart \u2014 ' +
          'discount code <strong style="color:#c9a84c">WELCOMEGIFT</strong> applied at checkout!' +
          '</span>'
        );
      })
      .catch(function (err) {
        console.log('[MFP Gift] Error:', err);
      });
  }

  /* ── Run after DOM is ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    // Slight delay so Shopify cart initializes
    setTimeout(run, 800);
  }
})();
